/** Customer-support contact details. Single source of truth for the support
 *  page, the dispute modals, and the Organization JSON-LD. */

export const SUPPORT_EMAIL = "support@ezspot.ai";

/** E.164, for `tel:` hrefs and schema.org `telephone`. */
export const SUPPORT_PHONE_TEL = "+17373397768";

/** Human-readable form; the vanity spelling with the digits alongside it. */
export const SUPPORT_PHONE_DISPLAY = "(737) 3EZ-SPOT (737-339-7768)";
